export const formatList = data => {
  if (!data?.length || !data[0]?.length) return []
  const patients = []

  // Group patients by summaries when available
  if (data[1]?.length) {
    data[1].forEach(s => {
      const knownPatient = patients.findIndex(p => p.id === s.accountId)
      const patient =
        knownPatient !== -1 ? patients[knownPatient] : data[0].find(p => p.id === s.patientId)
      if (patient) {
        if (knownPatient === -1) {
          patients.push({
            ...patient,
            registrationId: patient.id,
            id: s.accountId,
            summaries: [s],
          })
        } else patients[knownPatient].summaries.push(s)
      }
    })
  }

  // Include patients without summaries (consulted/closed)
  data[0].forEach(p => {
    if (!patients.find(existing => existing.registrationId === p.id || existing.id === p.id)) {
      patients.push({
        ...p,
        registrationId: p.id,
        summaries: [],
      })
    }
  })

  patients.forEach(p => p.summaries?.sort((a, b) => (a.statusTime > b.statusTime ? -1 : 1)))
  return patients
}
